import store from "@/store";

export const getAdminToken = ()=>{
	return store.getters['admin/getToken']
}

export const setAdminToken = (token)=>{
	return store.commit('admin/setToken',token)
}
